import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import CssBaseline from "@mui/material/CssBaseline";
import useScrollTrigger from "@mui/material/useScrollTrigger";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Fab from "@mui/material/Fab";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import Fade from "@mui/material/Fade";
import IconButton from "@mui/material/IconButton";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { Segment } from "semantic-ui-react";
import "../../../scss/index.scss";
import { estiloSegmento } from "../../../estilos/segmentos";
import { cancelar, inicio, si } from "../../../utils/traductor";
import { ENTORNO } from "../../../utils/constantes";
import { getrole, setTitulo } from "../../../utils/variablesLocales";
import { Grid } from "semantic-ui-react";
import "../../../scss/index.scss";
import LogoutIcon from "@mui/icons-material/Logout";
import "../../../scss/index.scss";
import IconoEmpresa from "@mui/icons-material/EmojiTransportation";
import IconoPrecioBase from "@mui/icons-material/MonetizationOn";
import IconoImportarNomina from "@mui/icons-material/RecentActors";
import IconoLocalidades from "@mui/icons-material/EditLocationAlt";
import IconoExportarABanco from "@mui/icons-material/SimCardDownload";
import IconoImportarDeBanco from "@mui/icons-material/UploadFile";
import IconoListaBlanca from "@mui/icons-material/LockPerson";
import Divider from "@mui/material/Divider";
import Paper from "@mui/material/Paper";
import MenuList from "@mui/material/MenuList";
import MenuItem from "@mui/material/MenuItem";
import ListItemText from "@mui/material/ListItemText";
import ListItemIcon from "@mui/material/ListItemIcon";
import Typography from "@mui/material/Typography";
import IconoPlantillasEmail from "@mui/icons-material/Email";
import IconoTextosVarios from "@mui/icons-material/TextSnippet";
import IconoUsuarios from "@mui/icons-material/Group";
import IconoSubastador from "@mui/icons-material/Gavel";
import Swal from "sweetalert2";
import { estiloColores } from "../../../estilos";
import { vas_a_cerrar_la_sesion } from "../../../utils/traductor";

function ScrollTop(props) {
  const { children, window } = props;
  // Note that you normally won't need to set the window ref as useScrollTrigger
  // will default to window.
  // This is only being set here because the demo is in an iframe.
  const trigger = useScrollTrigger({
    target: window ? window() : undefined,
    disableHysteresis: true,
    threshold: 100,
  });

  const handleClick = (event) => {
    const anchor = (event.target.ownerDocument || document).querySelector(
      "#back-to-top-anchor"
    );

    if (anchor) {
      anchor.scrollIntoView({
        block: "center",
      });
    }
  };

  return (
    <Fade in={trigger}>
      <Box
        onClick={handleClick}
        role="presentation"
        sx={{ position: "fixed", bottom: 16, right: 16 }}
      >
        {children}
      </Box>
    </Fade>
  );
}

ScrollTop.propTypes = {
  children: PropTypes.element.isRequired,
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window: PropTypes.func,
};

export function Inicio(props) {
  setTitulo("Inicio");

  const navigate = useNavigate();

  const irAEmpresas = () => {
    navigate(ENTORNO.URL_APLICACION + "/Administrador/EmpresaConsulta");
  };

  const irAPreciosBase = () => {
    navigate(ENTORNO.URL_APLICACION + "/Administrador/PrecioConsulta");
  };

  const irAImportarNomina = () => {
    navigate(ENTORNO.URL_APLICACION + "/Administrador/ImportarNomina");
  };

  const irALocalidades = () => {
    navigate(ENTORNO.URL_APLICACION + "/Administrador/LocalidadConsulta");
  };

  const irAListaBlancas = () => {
    navigate(ENTORNO.URL_APLICACION + "/Administrador/ListaBlancaConsulta");
  };

  const irAUsuarios = () => {
    navigate(ENTORNO.URL_APLICACION + "/Administrador/UsuarioConsulta");
  };

  const irAPlantillasEmail = () => {
    navigate(ENTORNO.URL_APLICACION + "/Administrador/EmailConsulta");
  };

  const irATextosVarios = () => {
    navigate(ENTORNO.URL_APLICACION + "/Administrador/TextoConsulta");
  };

  const irAExportarBanco = () => {
    navigate(ENTORNO.URL_APLICACION + "/Administrador/ExportarBanco");
  };

  const irAImportarBanco = () => {
    navigate(ENTORNO.URL_APLICACION + "/Administrador/ImportarBanco");
  };

  const irASubastador = () => {
    navigate(ENTORNO.URL_APLICACION + "/Administrador/Subastador");
  };

  useEffect(() => {
    (async () => {
      try {
        //controlando la seguridad para que solo acceda a esta pantalla el perfil que corresponda
        if (getrole() !== "Administrador") {
          navigate(ENTORNO.URL_APLICACION + "/CerrarSesion");
        }
        ///////////////////////////////////////////////////////
      } catch (error) {
        console.error(error);
      }
    })();
  });

  const EditarPerfil = async () => {
    navigate(ENTORNO.URL_APLICACION + "/Administrador/EditarPerfil");
  };

  const CerrarSesion = async () => {
    Swal.fire({
      title: vas_a_cerrar_la_sesion,
      text: "",
      // type: "warning",
      showCancelButton: true,
      confirmButtonText: si,
      confirmButtonColor: estiloColores.Azul,
      cancelButtonText: cancelar,
      cancelButtonColor: estiloColores.Gris,
    }).then((result) => {
      if (result.value) {
        navigate(ENTORNO.URL_APLICACION + "/CerrarSesion");
      }
    });
  };

  return (
    <div style={{ overfxlow: "hidden", touchAction: "none" }}>
      <React.Fragment>
        <CssBaseline />
        <AppBar style={{ background: "#DC030E" }}>
          <Toolbar>
            <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
              {inicio}
            </Typography>
            <IconButton
              size="large"
              onClick={EditarPerfil}
              edge="end"
              color="inherit"
            >
              <AccountCircleIcon />
            </IconButton>
          </Toolbar>
        </AppBar>
        <Toolbar id="back-to-top-anchor" />
        <Container>
          <Box sx={{ my: 2 }}>
            <Segment style={estiloSegmento.Pasajero}>
              <Grid
                textalign="center"
                container
                style={{ padding: "0em 0em", width: "100%" }}
              >
                <Grid.Row
                  textalign="center"
                  style={{
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <br></br>
                  <MenuList>
                    <MenuItem>
                      <ListItemText>
                        <h3>Menú principal</h3>
                      </ListItemText>
                    </MenuItem>
                    <Divider />
                    <MenuItem onClick={irAEmpresas}>
                      <ListItemIcon>
                        <IconoEmpresa></IconoEmpresa>
                      </ListItemIcon>
                      <ListItemText>Empresas</ListItemText>
                    </MenuItem>
                    <MenuItem onClick={irAPreciosBase}>
                      <ListItemIcon>
                        <IconoPrecioBase></IconoPrecioBase>
                      </ListItemIcon>
                      <ListItemText>Precios base</ListItemText>
                    </MenuItem>
                    <MenuItem onClick={irAImportarNomina}>
                      <ListItemIcon>
                        <IconoImportarNomina></IconoImportarNomina>
                      </ListItemIcon>
                      <ListItemText>Importar nómina</ListItemText>
                    </MenuItem>
                    {/* <Divider />
                    <MenuItem onClick={irALocalidades}>
                      <ListItemIcon>
                        <IconoLocalidades></IconoLocalidades>
                      </ListItemIcon>
                      <ListItemText>Localidades</ListItemText>
                    </MenuItem> */}
                    <Divider />
                    <MenuItem onClick={irAListaBlancas}>
                      <ListItemIcon>
                        <IconoListaBlanca></IconoListaBlanca>
                      </ListItemIcon>
                      <ListItemText>Lista blanca</ListItemText>
                    </MenuItem>
                    <MenuItem onClick={irAUsuarios}>
                      <ListItemIcon>
                        <IconoUsuarios></IconoUsuarios>
                      </ListItemIcon>
                      <ListItemText>Usuarios</ListItemText>
                    </MenuItem>
                    <Divider />
                    <MenuItem onClick={irAExportarBanco}>
                      <ListItemIcon>
                        <IconoExportarABanco></IconoExportarABanco>
                      </ListItemIcon>
                      <ListItemText>Exportar a banco</ListItemText>
                    </MenuItem>
                    <MenuItem onClick={irAImportarBanco}>
                      <ListItemIcon>
                        <IconoImportarDeBanco></IconoImportarDeBanco>
                      </ListItemIcon>
                      <ListItemText>Importar de banco</ListItemText>
                    </MenuItem>
                    <Divider />
                    <MenuItem onClick={irAPlantillasEmail}>
                      <ListItemIcon>
                        <IconoPlantillasEmail></IconoPlantillasEmail>
                      </ListItemIcon>
                      <ListItemText>Plantillas de email</ListItemText>
                    </MenuItem>
                    <MenuItem onClick={irATextosVarios}>
                      <ListItemIcon>
                        <IconoTextosVarios></IconoTextosVarios>
                      </ListItemIcon>
                      <ListItemText>Textos varios</ListItemText>
                    </MenuItem>
                    {/* <Divider />
                    <MenuItem onClick={irASubastador}>
                      <ListItemIcon>
                        <IconoSubastador></IconoSubastador>
                      </ListItemIcon>
                      <ListItemText>Subastador</ListItemText>
                    </MenuItem> */}
                  </MenuList>
                </Grid.Row>
              </Grid>
            </Segment>
          </Box>
        </Container>
        <ScrollTop {...props}>
          <Fab size="small" aria-label="scroll back to top">
            <KeyboardArrowUpIcon />
          </Fab>
        </ScrollTop>
        <AppBar
          position="fixed"
          color="primary"
          sx={{ top: "auto", bottom: 0 }}
        >
          <Toolbar style={{ background: "white", color: "#153B5E" }}>
            <Box sx={{ flexGrow: 1 }} />
            <IconButton color="inherit" onClick={(e) => CerrarSesion(e)}>
              <LogoutIcon />
            </IconButton>
          </Toolbar>
        </AppBar>
      </React.Fragment>
    </div>
  );
}
